import { auth, firebase } from './firebase';

function getStaticEmailAuthProvider() {
    return firebase.auth.EmailAuthProvider;
}

function getStaticGoogleAuthProvider() {
    return firebase.auth.GoogleAuthProvider;
}

function getStaticFacebookAuthProvider() {
    return firebase.auth.FacebookAuthProvider;
}

function getStaticTwitterAuthProvider() {
    return firebase.auth.TwitterAuthProvider;
}

// Sign Up
function doSignUpWithEmailAndPassword(email, password) {
    return auth.createUserWithEmailAndPassword(email, password);
}

// Sign In
function isSignInWithEmailLink(href) {
    return auth.isSignInWithEmailLink(href);
}

function doFetchSignInMethod(email) {
    return auth.fetchSignInMethodsForEmail(email);
}

function doSendSignInLinkToEmail(email, actionCodeSettings) {
    return auth.sendSignInLinkToEmail(email, actionCodeSettings);
}

function doSignInWithEmailLink(email, link) {
    return auth.signInWithEmailLink(email, link);
}

function doSignInWithEmailAndPassword(email, password) {
    return auth.signInWithEmailAndPassword(email, password);
}

function doSignInWithGoogle() {
    const provider = new firebase.auth.GoogleAuthProvider();
    provider.addScope('profile');
    provider.addScope('email');
    return auth.signInWithPopup(provider);
}

function doSignInWithFacebook() {
    const provider = new firebase.auth.FacebookAuthProvider();
    provider.addScope('email');
    return auth.signInWithPopup(provider);
}

function doSignInWithTwitter() {
    const provider = new firebase.auth.TwitterAuthProvider();
    return auth.signInWithPopup(provider);
}

// Sign out
function doSignOut() {
    return auth.signOut();
}

// Password Reset
function doPasswordReset(email) {
    return auth.sendPasswordResetEmail(email);
}

// Password Change
function doPasswordUpdate(password) {
    return auth.currentUser.updatePassword(password);
}

const authentication = {
    getStaticEmailAuthProvider,
    getStaticGoogleAuthProvider,
    getStaticFacebookAuthProvider,
    getStaticTwitterAuthProvider,
    doSignUpWithEmailAndPassword,
    isSignInWithEmailLink,
    doFetchSignInMethod,
    doSendSignInLinkToEmail,
    doSignInWithEmailLink,
    doSignInWithEmailAndPassword,
    doSignInWithGoogle,
    doSignInWithFacebook,
    doSignInWithTwitter,
    doSignOut,
    doPasswordReset,
    doPasswordUpdate
}
export default authentication;
